export const UNIT_OPTIONS = ['adet', 'kg', 'gr', 'lt', 'ml', 'm', 'cm', 'm²', 'm³', 'çift', 'paket', 'kutu', 'top', 'rulo'] as const;

export const ALT_UNIT_SUGGESTIONS = [...UNIT_OPTIONS, 'çuval', 'koli', 'teneke', 'kasa', 'bidon', 'deste'];
